module.exports = __webpack_public_path__ + "img/VL_10_03.b5a57efc.png";